import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "shim-selected-options";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';

import store from './store';
import App from './App';
import * as serviceWorker from './serviceWorker';

import './assets/scss/app.scss';


ReactDOM.render(
    <ReduxProvider store={store}>
        <App />
    </ReduxProvider>,
    document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
